export const CampaignScheduleScope = {
    Brand: 0,
    Location: 1,
    LocationGroup: 2,
} as const;

export type CampaignScheduleScope = (typeof CampaignScheduleScope)[keyof typeof CampaignScheduleScope];

// ----- Campaign -----
export interface Campaign {
    id: string;
    brandId: string;
    name: string;
    instruction: string;
    questionIds: string[];
    created: string;
    createdBy: string;
    updated?: string | null;
    updatedBy?: string | null;
}

export interface CreateCampaign {
    brandId: string;
    name: string;
    instruction: string;
    questionIds: string[];
}

export interface UpdateCampaign {
    name: string;
    instruction: string;
    questionIds: string[];
}

// ----- Question -----

// How a question is answered. RatingScale must stay 0: it is what every question that predates free text is,
// all the way down to the database column default.
export const QuestionType = {
    RatingScale: 0,
    FreeText: 1,
} as const;

export type QuestionType = (typeof QuestionType)[keyof typeof QuestionType];

export interface Question {
    id: string;
    brandId: string;
    name: string;
    questionType: QuestionType;

    // The rating at or below which an answer alerts a manager. Always 0 for a free-text question - it has no
    // scale to sit at the bottom of, and the API normalises it rather than trusting what the form sends.
    trigger: number;
    created: string;
    createdBy: string;
    updated?: string | null;
    updatedBy?: string | null;
}

export interface CreateQuestion {
    brandId: string;
    name: string;
    questionType: QuestionType;
    trigger: number;
}

export interface UpdateQuestion {
    name: string;
    questionType: QuestionType;
    trigger: number;
}

// ----- CampaignSchedule -----
export interface CampaignSchedule {
    id: string;
    campaignId: string;
    scope: CampaignScheduleScope;
    brandId?: string | null;
    locationId?: string | null;
    locationGroupId?: string | null;
    startDateTime: string;
    endDateTime: string;
    created: string;
    createdBy: string;
    updated?: string | null;
    updatedBy?: string | null;
}

export interface CreateCampaignSchedule {
    scope: CampaignScheduleScope;
    brandId?: string | null;
    locationId?: string | null;
    locationGroupId?: string | null;
    startDateTime: string;
    endDateTime: string;
}

export type UpdateCampaignSchedule = CreateCampaignSchedule;
